import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import ProfileList from '../ProfileList/ProfileList';
import RecommendationUser from '../RecommendationUser/RecommendationUser';
import Avtar from '../../../asset/avtar.png';
import user from '../../../asset/popup/user.webp';
import './JobDetailsModal.scss';

const MobileJobDetails = ({ 
  applications, 
  recommendedUsers, 
  selectedProfile, 
  selectedRecommendedUser,
  handleSelect,
  selectedData,
  handleRecommendedUserSelect,
  jobDetails
}) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('applications');

  const getProfileList = () => {
    const absoluteMatchCount = recommendedUsers?.absoluteMatch?.length || 0;
    if (absoluteMatchCount >= 5) {
      return recommendedUsers?.absoluteMatch?.slice(0, 5);
    } else {
      const needed = 5 - absoluteMatchCount;
      return [...(recommendedUsers?.absoluteMatch || []), ...(recommendedUsers?.similarMatch?.slice(0, needed) || [])];
    }
  };
  
  return (
    <div className="mobile-job-details">
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between',
        padding: '10px',
        borderBottom: '1px solid #ddd'
      }}>
        <Button 
          variant={activeTab === 'applications' ? 'contained' : 'outlined'}
          onClick={() => setActiveTab('applications')}
          sx={{ width: '48%' }}
        >
          Applications
        </Button>
        <Button 
          variant={activeTab === 'suggested' ? 'contained' : 'outlined'}
          onClick={() => setActiveTab('suggested')}
          sx={{ width: '48%' }}
        >
          Suggested Profiles
        </Button>
      </Box>

      <Box sx={{ padding: '10px' }}>
        {activeTab === 'applications' ? (
          <div className="mobile-profile-list">
            {applications?.length === 0 ? (
              <Typography sx={{ textAlign: 'center', padding: '20px' }}>
                No Applications Available
              </Typography>
            ) : (
              applications?.map((data) => (
                <div 
                  key={data.id} 
                  onClick={() => {
                    handleSelect(selectedProfile);
                    navigate('/job-details/profile', { state: { profile: data, type: 'application' , selectedRecommendedUser:data.id ,
                      selectedData:selectedData , selectedProfiles:selectedProfile} });
                  }}
                >
                  <ProfileList
                    selectedProfile={selectedProfile || Avtar}
                    data={data}
                    img={user}
                  />
                </div>
              ))
            )}
          </div>
        ) : (
          <div className="mobile-profile-list">
            {getProfileList()?.length === 0 ? (
              <Typography sx={{ textAlign: 'center', padding: '20px' }}>
                No Suggested Profiles Available
              </Typography>
            ) : (
              getProfileList()?.map((data) => (
                <div 
                  key={data.id}
                  onClick={() => {
                    handleRecommendedUserSelect(data);
                    navigate('/job-details/profile', { state: { profile: data, type: 'suggested' , selectedRecommendedUser:data.id ,
                      selectedData:selectedData
                     } });
                  }}
                >
                  <RecommendationUser
                    data={data}
                    img={user}
                    selectedRecommendedUser={selectedRecommendedUser}
                  />
                </div>
              ))
            )}
          </div>
        )}
      </Box>
    </div>
  );
};

export default MobileJobDetails; 